/**
 * How a role key reads on screen.
 *
 * The keys themselves (`buyer`, `supplier`, `super_admin`) are stored and
 * checked by the servers and never change. Only the label does: a buyer login
 * is a "Data buyer login".
 */
import type { Vocab } from './vocab';

export function roleLabel(v: Vocab, role: string | null | undefined): string {
  switch (role) {
    case 'super_admin': return 'Super admin';
    case 'admin': return 'Admin';
    case 'manager': return 'Manager';
    case 'analyst': return 'Analyst';
    case 'viewer': return 'Viewer';
    case 'unapproved': return 'Awaiting approval';
    case 'buyer': return v.p.roleBuyer;
    case 'supplier': return v.p.roleSupplier;
    case 'sales': return v.p.roleSales;
    case null:
    case undefined:
    case '': return 'User';
    default: {
      const words = role.replace(/_/g, ' ');
      return words.charAt(0).toUpperCase() + words.slice(1);
    }
  }
}
